module.exports = __webpack_public_path__ + "static/img/about-01.df5792e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-01.png
// module id = r5hA
// module chunks = 0